import { render, staticRenderFns } from "./header-title.vue?vue&type=template&id=53d22580&scoped=true&"
import script from "./header-title.vue?vue&type=script&lang=js&"
export * from "./header-title.vue?vue&type=script&lang=js&"
import style0 from "./header-title.vue?vue&type=style&index=0&id=53d22580&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d22580",
  null
  
)

export default component.exports